// ** Routes Imports
import { lazy } from "react";
// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template";

// ** Default Route
const DefaultRoute = "/dashboard";

const Routes = [
	{
		path: "/",
		component: lazy(() => import("../../ui/pages/SignIn")),
		layout: "BlankLayout",
		exact: true,
		meta: {
			authRoute: true,
		},
	},
	{
		path: "/signin",
		component: lazy(() => import("../../ui/pages/SignIn")),
		layout: "BlankLayout",
		exact: true,
		meta: {
			authRoute: true,
		},
	},

	{
		path: "/not-authorized",
		component: lazy(() =>
			import("../../ui/components/Error/NotAuthorized"),
		),
		layout: "BlankLayout",
		meta: {
			publicRoute: true,
		},
	},
	{
		path: "/not-found",
		component: lazy(() => import("../../ui/components/Error/404")),
		layout: "BlankLayout",
		meta: {
			publicRoute: true,
		},
	},
	{
		path: "/error",
		component: lazy(() => import("../../ui/components/Error/404")),
		layout: "BlankLayout",
		meta: {
			publicRoute: true,
		},
	},
	{
		path: "/forgot-password",
		component: lazy(() => import("../../ui/pages/ForgotPassword")),
		layout: "BlankLayout",
		meta: {
			publicRoute: true,
		},
	},
	{
		path: "/reset-password/:username/:number",
		component: lazy(() => import("../../ui/pages/ResetPassword")),
		layout: "BlankLayout",
		meta: {
			publicRoute: true,
		},
	},
	// {
	//     path: "/verify-email/:id",
	//     component: lazy(() => import("../../ui/pages/VerifyEmail")),
	//     type: "admin",
	//     layout: "BlankLayout",
	//     meta: {
	//         publicRoute: true,
	//     },
	// },
	{
		path: "/dashboard",
		component: lazy(() => import("../../ui/pages/Dashboard")),
		moduleName: "Dashboard",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/projections",
		component: lazy(() => import("../../ui/pages/Projections")),
		moduleName: "Projections",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/salesdata",
		component: lazy(() => import("../../ui/pages/Sales Data")),
		moduleName: "Sales Data",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/salesdatadatewise",
		component: lazy(() => import("../../ui/pages/Sales Data Datewise")),
		moduleName: "Sales Data(Datewise)",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/cnf-wise",
		component: lazy(() => import("../../ui/pages/CNFWise")),
		moduleName: "CNF Wise",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/brand-wise",
		component: lazy(() => import("../../ui/pages/BrandWise")),
		moduleName: "Brand Wise",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/product-stock",
		component: lazy(() => import("../../ui/pages/ProductStock")),
		moduleName: "Product Stock",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/dc-register",
		component: lazy(() => import("../../ui/pages/DC-Register")),
		moduleName: "DC Register",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/provisional-statement",
		component: lazy(() => import("../../ui/pages/ProvisionalStatement")),
		moduleName: "Provisional Statement",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/onward-sample-dispatch",
		component: lazy(() => import("../../ui/pages/OnwardSampleDispatch")),
		moduleName: "Onward Sample Dispatch",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},
	{
		path: "/employee-rights",
		component: lazy(() => import("../../ui/pages/EmployeeRights")),
		moduleName: "Employee Rights",
		// layout: "BlankLayout",
		// exact: true,
		// meta: {
		//     authRoute: true,
		// },
	},

	{
		path: "/settings",
		component: lazy(() => import("../../ui/pages/Settings")),
		moduleName: "Settings",
	},
	// {
	//     path: "/dashboard",
	//     component: lazy(() => import("../../ui/pages/Users")),
	//     type: "admin",
	//     layout: "BlankLayout",
	//     meta: {
	//         authRoute: true,
	//     },
	// },

	// ******* Users Routes *******

	// User Login Required Routes
	{
		path: "/change-password",
		component: lazy(() => import("../../ui/pages/ChangePassword")),
		type: "User",
		layout: "BlankLayout",
		exact: true,
		authRoute: true,
	},
];

export { DefaultRoute, TemplateTitle, Routes };
